<template>
  <div>
    <section class="aui-flexView">
      <section class="aui-scrollView">
        <div class="m-slider" data-ydui-slider>
          <div class="slider-wrapper">
            <div class="slider-item" v-for="(imgUrl, index) in bannerList" v-show="index===mark" :key="index" >
              <a href="javascript:;">
                <img :src=imgUrl>
              </a>
            </div>
          </div>
          <div class="slider-pagination"></div>
        </div>
        <div class="divHeight"></div>
        <div class="aui-palace">
          <router-link :to="{ name: 'zaixianlianxi' }">
          <a href="javascript:;" class="aui-palace-grid">
            <div class="aui-palace-grid-icon">
              <img src="../assets/img/icon-ge-001.png" alt="">
            </div>
            <div class="aui-palace-grid-text">
              <h2>模拟考试</h2>
            </div>
          </a>
          </router-link>
          <router-link :to="{ name: 'kaoshi' }">
          <a href="javascript:;" class="aui-palace-grid">
            <div class="aui-palace-grid-icon">
              <img src="../assets/img/icon-ge-002.png" alt="">
            </div>
            <div class="aui-palace-grid-text">
              <h2>在线考试</h2>
            </div>
          </a>
          </router-link>
          <router-link :to="{ name: 'stceyan' }">
          <a href="javascript:;" class="aui-palace-grid">
            <div class="aui-palace-grid-icon">
              <img src="../assets/img/icon-ge-003.png" alt="">
            </div>
            <div class="aui-palace-grid-text">
              <h2>随堂测验</h2>
            </div>
          </a>
          </router-link>
          <router-link :to="{ name: 'cuotiku' }">
          <a href="javascript:;" class="aui-palace-grid">
            <div class="aui-palace-grid-icon">
              <img src="../assets/img/icon-ge-004.png" alt="">
            </div>
            <div class="aui-palace-grid-text">
              <h2>我的错题</h2>
            </div>
          </a>
          </router-link>
          <router-link :to="{ name: 'studentcj' }">
          <a href="javascript:;" class="aui-palace-grid">
            <div class="aui-palace-grid-icon">
              <img src="../assets/img/icon-ge-005.png" alt="">
            </div>
            <div class="aui-palace-grid-text">
              <h2>我的成绩</h2>
            </div>
          </a>
          </router-link>
          <router-link :to="{ name: 'myshoucang' }">
          <a href="javascript:;" class="aui-palace-grid">
            <div class="aui-palace-grid-icon">
              <img src="../assets/img/icon-ge-006.png" alt="">
            </div>
            <div class="aui-palace-grid-text">
              <h2>我的收藏</h2>
            </div>
          </a>
          </router-link>
        </div>
        <div class="divHeight"></div>

        <div class="aui-login-box">
          <div class="aui-login-item">
            <div class="aui-login-head b-line">
              <div class="aui-flex">
                <div class="aui-lo-img">
                  <img src="../assets/img/order.png" alt="">
                </div>
                <div class="aui-flex-box">
                  <h3>我的考试任务</h3>
                </div>
              </div>
              <div class="aui-login-button">

              </div>
            </div>
            <div class="list" v-if="isks">
              <van-row   class="xitem" justify="space-between">
                <van-col span="18">
                  <h4>{{ data.paperDesc }} ( {{ paperValue}}分)</h4>
                  <p>考试时间：{{ data.kstarttime }} ~ {{ data.kendtime }}</p>
                  <p>考试时长：{{ data.exam_time }}</p>
                </van-col>
                <van-col span="5">
                  <span :class="data.ssjj != 'Y' ? 'ing' : 'end'">{{ data.ssjj=='Y'?'已完成考试':'正在考试...' }}</span>
                </van-col>
                <van-col span="24">
                  <div
                    v-if="data.ssjj != 'Y'"
                    class="enter"
                    @click="kaoshi"
                  >进入考试<van-icon name="arrow" />
                  </div>
                </van-col>
              </van-row>
            </div>
            <div class="list" v-if="!isks">
              <van-row   class="xitem" justify="space-between">
              <van-col >
              {{msgmx}}
              </van-col>
              </van-row>
            </div>
            <div class="aui-login-more">
              <router-link :to="{ name: 'kaoshi' }"> <a href="javascript:;">更多考试任务...</a></router-link>
            </div>
            <div style="width: 100%;height: 100%" v-html="'&nbsp;'">
            </div>
          </div>
        </div>
        <div style="height:50px;"></div>
      </section>
    </section>
 <mtabbar></mtabbar>
  </div>
</template>

<script>
import upimg from './common/uploadimg.vue';
export default {
  data() {
    return {
      data: {},
      isks: false,
      kssc: "",
      kssj: "",
      mark: 0, //比对图片索引的变量
      msgmx:'',
      paperValue:0,
      bannerList:[
        require('../assets/img/banner-002.png'),
        require('../assets/img/banner-002.png'),
        require('../assets/img/banner-002.png'),
        require('../assets/img/banner-002.png')
      ],
      queryParamstp:{
        lx:'学生端',
      },
    };
  },
  created() {
    let aqjc = localStorage.getItem("aqjc");
    if(aqjc == 'N'){
      this.$ajax.post('/logout', {}).then(function(res) {
        if (res.code == 200) {
          localStorage.clear();
          localStorage.removeItem("Token");
          location.href = '/login?cancellation=1';
        }
      });
    }
    this.getuser();
    localStorage.setItem('currentpath', this.$router.currentRoute.fullPath);
    this.play();
    this.getstudent();

  },
  methods: {
    getuser(){
      let that = this,i = 0;
      let data = {params:this.queryParamstp}
      that.$ajax.get('/system/image/list',data).then(function(res) {
        if(res.rows.length > 0){
          that.bannerList = [];
          for(i = 0;i < res.rows.length;i++){
            that.bannerList.push(that.$global.paperfileapi + res.rows[i].url);
          }
        }
      });
    },
    kaoshi() {
      let that =this
      this.$ajax.get('/student/examonline/studenttask').then(function(res) {
        if (res.code == 200) {
          if (res.data.ssjj == 'Y') {
            that.$toast.fail('已经考过，不能进入考试！');
          } else {
            that.$router.push({ name: 'kaikao', params: { id: res.data.ksmxid} });
          }
        }
        if(res.code == 401)
        {
          location.href = '/login';
        }
      })
    },
    getstudent() {
      let that = this;
      this.$ajax.get('/student/examonline/studenttask').then(function (res) {
        if (res.code == 200) {
          that.data = res.data;
          that.kssc = "试卷时长：" + that.data.exam_time + " 分钟"
          that.kssj = "考试时间：" + that.data.kstarttime + " - " + that.data.kendtime
          that.paperValue = that.data.paperinfo.paperValue
          if ("Y" == that.data.ssjj) {
            that.kssj = "已完成考试";
          }
          that.isks = true;
        } else {
          that.msgmx = res.msg ;
          that.isks = false;
        }
        if (res.code == 401) {
          location.href = '/login';
        }

      })

    },
    prevIndex(){
      this.mark = this.mark - 1;
      if(this.mark < 0){
        this.mark = 2;
      }
      console.log(this.mark);
    },
    nextIndex(){
      this.mark = this.mark + 1;
      if(this.mark == this.bannerList.length){
        this.mark = 0;
      }
      console.log(this.mark);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    autoPlay () {
      this.mark++;
      if (this.mark === this.bannerList.length) { //当遍历到最后一张图片置零
        this.mark = 0
      }
    },
    play () {
      setInterval(this.autoPlay, 4000)
    },
    change (i) {
      this.mark = i
    }
  }
};
</script>

<style lang="scss" scoped>
  @import url('../assets/css/style.css');
.sudoku_row {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  padding: 2px;
}
.sudoku_item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 32%;
  padding-top: 10px;
  padding-bottom: 10px;
}
.opacity {
  opacity: 0.4;
  background: #e5e5e5;
}
.sudoku_item img {
  margin-left: 10px;
  margin-bottom: 3px;
  display: block;
  align-items: center;
}

.head {
  height: auto;
  width: 100%;
}
.Grid {
  display: flex;
  flex-direction: column;
  height: 700px;
}
.Grid-cell {
  flex: 1;
}
.Grid-cell.u-1of4 {
  flex: 0 0 25%;
}
.Grid-cell.u-1of3 {
  flex: 0 0 33.3333%;
}
.Grid-cell.u-1of2 {
  flex: 0 0 50%;
}
.Grid-cell.u-full {
  flex: 0 0 100%;
}
  .list{
    text-align: left;
  .xitem{

    margin-bottom: .9375rem;
    border-radius: 5px;
    padding: .9375rem 1.25rem;
  h4{
    margin: 0;
    line-height: 1.375rem;
    margin-bottom: .5rem;
  }
  p{
    color: #757DA3;
    font-size: .75rem;
    margin: 0;
    margin-top: .125rem;
    line-height: 1.0625rem;
  }
  .enter{
    color: #757DA3;
    display: flex;
    font-size: .875rem;
    justify-content: space-between;
    padding-top: .9375rem;
    margin-top: .625rem;
    position: relative;
  &::after{
     position: absolute;
     width: calc(100% + 2.5rem);
     left: -1.25rem;
     top: 0;
     content: '';
     height: 1px;
     background-color: #EBEBEB;
   }
  }
  span{
    font-size: .75rem;
  &.ing{
     color: #F86969;
   }
  &.end{
     color: #7469F8;
   }
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/student.vue